<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-clock text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Estatus
        </span>
      </div>
    </div>
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em
              class="radius"
              :class="`fas fa-${getIconStatus(item.statusId)}`"
            />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.createDate | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.createDate | hour }}
              </div>
            </div>
          </template>
          <div class="row py-4 mx-3">
            <div class="col-md-2 col-sm-12">
              <custom-balloon
                :background-color="` bg-${getColorStatus(item.statusId)}`"
                :text="item.statusName"
              />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div
                  v-if="item.determinationReasonUserName"
                  class="col ml-5 ml-md-5 ml-sm-0"
                >
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Determinado por:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.createUserName }}
                  </div>
                </div>
                <div v-else class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Realizado por:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.createUserName }}
                  </div>
                </div>
                <div
                  v-if="item.determinationReasonUserName"
                  class="col ml-5 ml-md-5 ml-sm-0"
                >
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Razón:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.determinationReasonDescription | empty }}
                  </div>
                </div>
              </div>
              <div
                v-if="viewComments(item.statusId, item.comments)"
                class="row bg-white rounded p-2 mt-3 ml-5 ml-md-5 ml-sm-0"
              >
                <div class="col">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Comentario:
                  </div>
                  <div
                    class="color-black font-16 font-weight-normal label-value"
                  >
                    {{ item.comments }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
    <div
      v-if="pageCount > 1"
      class="d-flex justify-content-center align-items-center mt-3"
    >
      <action-button
        class="btn-see-more"
        i="fas fa-chevron-down"
        text="Ver más"
        variant="outline-success rounded-pill px-5"
        @click="$emit('on-load-more')"
      />
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import requestServiceStatuses from '@/utils/constants/student/provisionalRemedyAnswerStatus.js';
import ServiceStatusColors from '@/utils/constants/rp/requestServiceStatusColors.js';

export default {
  name: 'RequestServiceStatusHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    CustomBalloon,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pageCount: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    getIconStatus() {
      return (statusId) => {
        return {
          [requestServiceStatuses.Nuevo]: 'file-user',
          [requestServiceStatuses.Aprobado]: 'check',
          [requestServiceStatuses.Objetado]: 'retweet',
          [requestServiceStatuses.Cancelado]: 'times-circle',
        }[statusId];
      };
    },
    getColorStatus() {
      return (statusId) => {
        return {
          [requestServiceStatuses.Nuevo]: ServiceStatusColors.Yellow,
          [requestServiceStatuses.Aprobado]: ServiceStatusColors.GreenLight,
          [requestServiceStatuses.Objetado]: ServiceStatusColors.Violet,
          [requestServiceStatuses.Cancelado]: ServiceStatusColors.Brown,
        }[statusId];
      };
    },
    viewComments() {
      return (statusId, comments) =>
        statusId !== requestServiceStatuses.Nuevo && comments;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';
.gradient-border {
  box-shadow: 8px 0 3px -3px #efefef !important;
}

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: map-get($colors, 'gray-2');
    color: map-get($colors, 'white');
    box-shadow: 0px 3px 6px #00000029;
  }
}
</style>
